"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PointModel$ = exports.PointModel$outboundSchema = exports.PointModel$inboundSchema = void 0;
exports.pointModelToJSON = pointModelToJSON;
exports.pointModelFromJSON = pointModelFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.PointModel$inboundSchema = z.object({
    coordinates: z.array(z.number()),
    type: z.literal("Point").default("Point").optional(),
});
/** @internal */
exports.PointModel$outboundSchema = z.object({
    coordinates: z.array(z.number()),
    type: z.literal("Point").default("Point"),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var PointModel$;
(function (PointModel$) {
    /** @deprecated use `PointModel$inboundSchema` instead. */
    PointModel$.inboundSchema = exports.PointModel$inboundSchema;
    /** @deprecated use `PointModel$outboundSchema` instead. */
    PointModel$.outboundSchema = exports.PointModel$outboundSchema;
})(PointModel$ || (exports.PointModel$ = PointModel$ = {}));
function pointModelToJSON(pointModel) {
    return JSON.stringify(exports.PointModel$outboundSchema.parse(pointModel));
}
function pointModelFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.PointModel$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'PointModel' from JSON`);
}
//# sourceMappingURL=pointmodel.js.map